import KFocused from '../../core/mixins/focused/KFocused'
import KIcon from '../icon'
import $ from 'jquery'

export default {
  name: 'KDropdownItem',
  mixins: [KFocused],
  inject: ['onItemClick', 'hasIcon'],
  props: {
    divider: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    action: {
      validator: () => true,
      default: null,
    },
    icon: {
      type: String,
      default: '',
    },
    // href: {
    //   type: String,
    //   default: '',
    // },
  },
  data() {
    return {
      tag: 'div',
    }
  },
  computed: {},
  watch: {},
  mounted() {},
  render() {
    if (this.divider) {
      return <div class="km-dropdown-item km-dropdown-item--divider">{this.$slots.default}</div>
    }

    const css = {
      'km-dropdown-item': true,
    }

    if (this.icon) {
      this.hasIcon()
      css['km-dropdown-item--has-icon'] = true
    }

    if (this.disabled) {
      css['is-disabled'] = true
    }

    if (this.$attrs.href) {
      this.tag = 'a'
    }

    return (
      <this.tag
        class={css}
        disabled={this.disabled}
        onClick={this.handleClick}
      >
        {this.icon ? <KIcon
          class="km-dropdown-item__icon"
          fixed-width
          icon={this.icon}
        /> : null}
        {this.$slots.default}
      </this.tag>
    )
  },
  methods: {
    handleClick(e) {
      let action = this.action
      if (action === null) {
        action = $(this.$el).text()
      }
      this.onItemClick(e, action, this)
    },
  },
}
